// Role IDs mirror arcspan_sandbox backend/api/users/v2/roles.py.
export const ROLE = {
	ADMIN: 1,
	PUBLISHER_ADMIN: 2,
	PUBLISHER_USER: 3,
	PUBLISHER_READ_ONLY_USER: 4,
	PUBLISHER_CONTRIBUTOR: 5,
};

// Roles that can create/edit audience *content* (name, criteria, TTL, etc.).
// Publisher Contributor (5) is an editor, but is separately barred from the
// lifecycle/delivery actions below. See ASB-3200.
const EDITOR_ROLES = [ROLE.ADMIN, ROLE.PUBLISHER_ADMIN, ROLE.PUBLISHER_USER, ROLE.PUBLISHER_CONTRIBUTOR];

// Roles that can change an audience's lifecycle (delete, archive/activate) or
// destination delivery (push/pull). Publisher Contributor is intentionally excluded.
const LIFECYCLE_DELIVERY_ROLES = [ROLE.ADMIN, ROLE.PUBLISHER_ADMIN, ROLE.PUBLISHER_USER];

// Admin-only surfaces. Kept as a named predicate rather than an inline
// `role_id != 1` so role vocabulary lives in one file (REVIEW.md 2.2). The
// authoritative contract for what each role may actually reach is
// arcspan_sandbox/.review/role-matrix.md; this only mirrors it.
export const isAdmin = (roleId) => roleId === ROLE.ADMIN;

export const canEditContent = (roleId) => EDITOR_ROLES.includes(roleId);
export const isReadOnly = (roleId) => !canEditContent(roleId);

// Delete, archive/activate, and push/pull to destinations all share one permission set.
export const canManageLifecycleAndDelivery = (roleId) => LIFECYCLE_DELIVERY_ROLES.includes(roleId);
// Alias for the destination-specific call sites (push/pull, Save & Push), same rule.
export const canManageDestinations = canManageLifecycleAndDelivery;

// Bulk Reporting Tool (ASB-4295): who may cancel a queued or generating report.
// Mirrors POST /bulk-reports/jobs/<id>/cancel (role-matrix.md): an ArcSpan Admin
// any job; a Publisher Admin any job on the ArcTag (the API scopes the tag to
// their publisher); everyone else, read-only included, only a job they submitted
// themselves. userId is the JWT's user_id (auth.js getUserId). Every role may
// submit, list and download, so those need no helper.
export const canCancelBulkReport = (roleId, job, userId) => {
	if (roleId === ROLE.ADMIN || roleId === ROLE.PUBLISHER_ADMIN) return true;
	const owner = job?.submitted_by?.user_id;
	return owner !== undefined && owner !== null && userId !== undefined && userId !== null && owner === userId;
};
